import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import RoundIconButton from "./RoundIconButton";
import IconCloseX from "~/components/icons/IconCloseX";

interface Props {
  isModalOpen: boolean;
  onCloseModal: () => void;
  withoutX?: boolean;
  children: React.ReactNode;
  width?: {
    desktopWidth?: string;
    mobileWidth?: string;
  };
  border?: string;
  background?: string;
  borderRadius?: string;
  alignSelf?: string;
  panelClassName?: string;
  isMaslekaPayment?: boolean;
}

const Modal = ({
  isModalOpen,
  onCloseModal,
  children,
  width,
  border,
  background,
  borderRadius,
  withoutX,
  panelClassName,
  isMaslekaPayment,
}: Props) => {
  return (
    <Transition.Root show={isModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[1300]" onClose={onCloseModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out-soft duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="transition-opacity fixed inset-0 bg-opacity-75 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-0 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out-soft duration-350"
              enterFrom="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={[
                  "transition-all relative w-full transform overflow-hidden rounded-b-none rounded-t-2xl bg-surface px-4 pb-6 pt-5 text-left shadow-xl sm:my-8 sm:w-auto sm:rounded-lg sm:p-6",
                  panelClassName,
                  borderRadius || "sm:rounded-lg",
                  border,
                  width?.mobileWidth,
                  width?.desktopWidth ? `xl:${width.desktopWidth}` : undefined,
                  background || "bg-surface",
                  "max-h-[90vh] overflow-y-auto text-left shadow-xl sm:max-h-screen sm:max-w-xl sm:overflow-y-auto xl:max-w-4xl",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <div>
                  {/* Grab handle — only on mobile bottom-sheet */}
                  <div className="mx-auto mb-3 h-1.5 w-10 rounded-full bg-gray-300 sm:hidden" />
                  {!withoutX && !isMaslekaPayment && (
                    <div className="mb-2 flex justify-end">
                      <RoundIconButton
                        icon={<IconCloseX />}
                        callback={() => {
                          onCloseModal();
                        }}
                      />
                    </div>
                  )}
                  <div>{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
